import { Route, Routes, useLocation } from "react-router-dom";
import "./App.css";
import HomePage from "./pages/HomePage";
import NavBar from "./components/nav/NavBar";
import Drawer from "./components/nav/Drawer";
import Footer from "./components/nav/Footer";
import utils from "./utils";
import { Toaster } from "react-hot-toast";
import HousesPage from "./pages/HousesPage";
import ContactPage from "./pages/ContactPage";
import ServicesPage from "./pages/ServicesPage";
import PageNotFound from "./pages/PageNotFound";
import { useEffect } from "react";
import HouseViewPage from "./pages/HouseViewPage";
import LoginPage from "./pages/LoginPage";
import DashboardPage from "./pages/DashboardPage";
import ProtectedRoutes from "./LoggedInReroutes";
import RedirectRoute from "./LoginRedirect";
import SessionInit from "./components/nav/SessionInit";
import AboutPage from "./pages/AboutPage";

function App(props) {
  const location = useLocation();

  useEffect(() => {
    const topNav = document.getElementById("nav-top");
    if (topNav) {
      setTimeout(() => {
        topNav.scrollIntoView({ behavior: "smooth" });
      }, 63);
    }
  }, [location]);
  return (
    <div className="App bg-background text-on-surface font-body antialiased">
      <SessionInit/>
      <div className="drawer drawer-start">
        <input id="nav-drawer" type="checkbox" className="drawer-toggle" />
        <div className="drawer-content">
          <div id="nav-top" className=""></div>
          <NavBar />
          <div className="h-20"></div>
          <div className="page">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/services" element={<ServicesPage />} />
              <Route path="/houses" element={<HousesPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/house/:slug" element={<HouseViewPage />} />
              <Route
                path="/auth/login"
                element={
                  <RedirectRoute>
                    <LoginPage />
                  </RedirectRoute>
                }
              />
              <Route
                path="/auth/dashboard"
                element={
                  <ProtectedRoutes>
                    <DashboardPage />
                  </ProtectedRoutes>
                }
              />
              <Route path="*" element={<PageNotFound />} />
            </Routes>
          </div>
          <Footer />
          <Toaster
            position={utils.toasterPoisition}
            toastOptions={utils.toasterOptions}
          />
        </div>
        <Drawer />
      </div>
    </div>
  );
}

export default App;
